var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    attrs: {
      "customClass": "embroidery-main-view-preview small-centered text-center"
    }
  }, [_c('base-spinner'), _c('CustomContainer', {
    attrs: {
      "id": "snapshot-image-scene"
    }
  }), _c('CustomContainer', {
    attrs: {
      "customClass": "row"
    }
  }, _vm._l(_vm.images, function (item, index) {
    return _c('CustomContainer', {
      key: item.caption,
      attrs: {
        "customClass": [{
          'columns small-6': _vm.itemsToPersonalize > 1
        }]
      }
    }, [_c('CustomContainer', {
      attrs: {
        "customClass": ['embroidery-main-view-preview-crop-image', {
          'side-model': _vm.isSideModel && !_vm.isUGCApplied
        }, {
          'tall-model': _vm.isTallModel
        }, {
          'ugc-applied': _vm.isUGCApplied && !_vm.isSideModel
        }, {
          'side-model-ugc': _vm.isUGCApplied && _vm.isSideModel
        }, {
          'embroidery-main-view-preview-first-image': index === 0 && _vm.itemsToPersonalize > 1
        }, {
          'embroidery-main-view-preview-single-image small-centered': _vm.itemsToPersonalize === 1
        }]
      }
    }, [_c('CustomImage', {
      attrs: {
        "alt": item.caption,
        "customClass": ['embroidery-main-view-preview-crop-image-img', {
          'side-model': _vm.isSideModel && !_vm.isUGCApplied
        }, {
          'tall-model': _vm.isTallModel
        }, {
          'ugc-applied': _vm.isUGCApplied && !_vm.isSideModel
        }, {
          'side-model-ugc': _vm.isUGCApplied && _vm.isSideModel
        }],
        "src": item.imgSrc
      },
      on: {
        "load": _vm.imageIsLoaded
      }
    })], 1)], 1);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }